<template lang="html">
  <div class="wrapper" :style="{ 'background-image': 'url(' + data.background + ')', 'background-color': '#EEEEEE' } " v-if="data">
    
    <div class="bg-progressbar" v-if="currentSurvey && currentSurvey.type =='standard'">
      <div v-if="!data.completed " class="container-fluid">
          <b-progress height="1.5rem">
            <b-progress-bar :value="valueProgressBar" :label="`${valueProgressBar}%`" variant="success"></b-progress-bar>
          </b-progress>
      </div>
    </div>

    <div class="bg-devices text-center">
      <div class="container-fluid" style="height: 100%;">
        
        <img :src="data.logo" alt="Logo de la compañia" class="logo">
        <div class="row justify-content-center">
          <div class="col-12 col-md-11 text-center">
            
            <div v-if="data.device.init_survey == 'switch' && !currentSurvey && !completed">
              <ul>
                <li v-for="(survey, index) in data.surveys" :key="survey.id">
                  <v-btn outline color="indigo" block :style="styleListSurveys" @click = "selectSurvey(index)" class="sizeOfList">
                    <span class="text-list-surveys">
                      {{survey.name}}
                    </span>
                  </v-btn>
                </li>  
              </ul>   
            </div>

            <div v-if="currentSurvey">
              
              <input type="text" id="latitude" value="" hidden="">
              <input type="text" id="longitude" value="" hidden="">
              <b-row>
                <survey-devices-standard 
                  v-if="currentSurvey.type == 'standard'" 
                  :survey="currentSurvey" 
                  :client="data.client"
                  :device="data.device"
                  :tokenResponse="tokenResponse"
                  v-on:reset-survey="resetSurvey"
                  v-on:update-progressbar="updateProgressBar"
                >
                </survey-devices-standard>
                <survey-devices-advanced
                  v-if="currentSurvey.type == 'advanced'"
                  :survey="currentSurveyAdvanced" 
                  :client="data.client"
                  :device="data.device"
                  v-on:reset-survey="resetSurvey"
                  :tokenResponse="tokenResponse"
                >
                </survey-devices-advanced>
                
              
              </b-row>
            </div>

            <div class="text-center" v-if="completed">
              <h2 v-html="messages.message_success ? messages.message_success : 'Encuesta contestada satisfactoriamente.'"></h2>
              <h3 v-html="messages.message_sub ? messages.message_sub : '¡Muchas gracias por tu tiempo!'"></h3>
              
            </div>

            <div class="text-center" v-if="data.surveys.length === 0">
              <h2>El Dispositivo no tiene encuestas asociadas</h2>
              <h3>¡Muchas gracias por tu tiempo!</h3>
            </div>

          </div>
        </div>

        <a :href="defaultWeb" target="_blank" :hidden="hiddenLogo" class="logo-footer-right" v-if="!currentSurvey">
          <img :src="defaultLogo" alt="Logo">

           <p v-if="completed">Click to learn more</p>
        </a>
        <a :href="defaultWeb" target="_blank" :hidden="hiddenLogo" class="logo-footer-content-right" v-if="currentSurvey">
          <img :src="defaultLogo" alt="Logo">
          <p v-if="completed">Click to learn more</p>
        </a>
       
      </div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './sass/survey.css';
import axios from 'axios';
import SurveyDevicesStandard from './componentSurveyDevices/SurveyStandard';
import SurveyDevicesAdvanced from './componentSurveyDevices/SurveyAdvanced';

Vue.use(BootstrapVue);

export default {
  components: {
    SurveyDevicesStandard,
    SurveyDevicesAdvanced
  },
  data: () => {
    return {
      steps: null,
      data: null,
      dataAdvanced: null,
      currentSurvey: null,
      currentSurveyAdvanced: null,
      stepsAdvanced: null,
      completed: false,
      tokenResponse: null,
      latitude: null,
      longitude: null,
      messages: null,
      valueProgressBar: 0,
      defaultLogo: process.env.LOGO_PATH,
      defaultWeb: process.env.URL_WEB
    };
  },
  computed: {
    styleListSurveys: function () {
      return {
        margin: 'auto', 
        color: this.data.client.color + ' !important',
        marginBottom: '1%',
      };
    },
    hiddenLogo: function () {
      if (this.data.client.hidden_logo_knower) {
        return true;
      }
      return false;
    }
  },
  mounted () {
    let self = this;
    navigator.geolocation.watchPosition(function (position) {
      self.latitude = position.coords.latitude;
      self.longitude = position.coords.longitude;
      localStorage.setItem('coords', 
        JSON.stringify({
          'latitude': self.latitude,
          'longitude': self.longitude
        })
      );
    }, function (error) {
      if (error.code === error.PERMISSION_DENIED) {
        localStorage.setItem('coords', 
          JSON.stringify({
            'latitude': null,
            'longitude': null
          })
        );
        console.log('Error, you denied location');
      }
    });
    this.loadData();
  },
  methods: {
    login () {
      this.$gtag.event('login', { method: 'Google' });
    },
    loadData () {
      let token = this.$route.params.token;
      let url = 'public/survey/device/' + token;
      
      axios.get(url).then(response => {
        this.data = response.data.data;
        if (this.data.device.init_survey === 'random') {
          setTimeout(function () {
            this.selectSurveyRandom();
          }.bind(this), 1000);
        } 
      }).catch(error => {
        console.log(error);
      });

      let urlAdvanced = 'public/v2/survey/device/' + token;
      axios.get(urlAdvanced).then(response => {
        this.dataAdvanced = response.data.data;
      }).catch(error => {
        console.log(error);
      });

    },
    selectSurvey (index) {
      this.currentSurvey = this.data.surveys[index];
      this.steps = this.currentSurvey.steps;

      this.currentSurveyAdvanced = this.dataAdvanced.surveys[index];
      this.stepsAdvanced = this.currentSurveyAdvanced.steps;

      this.tokenResponse = this.generateUuid();
    },
    selectSurveyRandom () {
      let random = Math.floor((Math.random() * this.data.surveys.length));
      this.currentSurvey = this.data.surveys[random];
      this.currentSurveyAdvanced = this.dataAdvanced.surveys[random];

      this.steps = this.currentSurvey.steps;
      this.stepsAdvanced = this.currentSurveyAdvanced.steps;

      this.tokenResponse = this.generateUuid();
    },
    resetSurvey (data) {
      this.token = null;
      this.completed = true;
      this.messages = data;
      this.currentSurvey = null;
      this.valueProgressBar = 0;

      if (data.auto_refresh) { 
        setTimeout(function () {
          this.completed = false;
        }.bind(this), 3000);
      }
      
      if (this.data.device.init_survey === 'random') {
        this.selectSurveyRandom();
      }
    },
    updateProgressBar (data) {
      this.valueProgressBar = data;
    },
    generateUuid () {
      let value = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
      return value;
    },
  }
};
</script>
<style lang="css">
  .text-list-surveys{
    white-space: normal;
    height:auto
  }
  li {
      list-style-type: none;
  }
  .sizeOfList {
    width: '45%',
  }
  .center-buttom-footer{
    top: 50%;
    transform: translateY(85%);
  }
  .logo-footer-right {
    width: 150px;
    float: right;
    margin-top: 10%;
  }
  .logo-footer-right img{
    width: 100%;
    display: block;
  }
  .logo-footer-left {
    width: 150px;
    float: left;
    margin-top: 9%;
  }
  .logo-footer-left img{
    width: 100%;
    display: block;
  }
  .logo-footer-content-left {
    width: 150px;
    float: left;
    margin-top: 9%;
  }
  .logo-footer-content-left img{
    width: 100%;
    display: block;
  }
  .logo-footer-content-right {
    width: 150px;
    margin-top: 5%;
    float: right;
  }
  .logo-footer-content-right img {
    width: 100%;
    display: block;
  }
  .progress-bar-top{
    background-color: white;
    margin-top: -20px;
  }

  @media only screen and (orientation: portrait) and (max-width: 475px)  {
    .logo-footer-right {
      width: 110px;
      position: absolute;
      bottom: 20px;
      left: 50%;
      margin-left: -55px;
    }
    .logo-footer-content-right {
      width: 110px;
      position: absolute;
      bottom: 20px;
      left: 50%;
      margin-left: -55px;
    }
    .sizeOfList {
      width: 95%;
    }
    .logo {    
      max-height: 130px
    }
    .center-buttom-footer{
      bottom: 35px;
      transform: translateY(85%);
    }
  }
   @media only screen and (min-width: 475px)  {
    .sizeOfList {
      width: 45%;
    }
    .logo {
      max-height: 150px
    }
    
  }
</style>



// WEBPACK FOOTER //
// src/surveys/SurveyDevices.vue